<script>
// import appConfig from '@src/app.config'
import { authComputed, deviceComputed } from '@state/helpers'
import { PushNotifications } from '@capacitor/push-notifications';
import { App } from '@capacitor/app';
// import { Badge } from '@robingenz/capacitor-badge';
import { mapActions } from 'vuex'
import router from '@router'
import { saveState, getSavedState } from '@utils/browser-help'

export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      const type = {
        'dingbeauty': 'DingBeauty',
        'ipetbooking': 'iPetBooking'
      }
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} | ${type[process.env.VUE_APP_DEV_MODE]}` : `${type[process.env.VUE_APP_DEV_MODE]}`
    },
  },
  data() {
    return {
      keydownContent:'',
      loadingRegisterDevice: false,
      loadingSetCurrentDeviceToken: false,
      loadingReadPush: false,
      echoPrivate: '',
    }
  },
  computed: {
    ...authComputed,
    ...deviceComputed,
    /**
     * fullPath 含 hash 時，僅變更 #fragment 也會改 key 導致整頁 remount（例如 schedule-check-in 用 #hotel 切 tab）。
     * 以 path+query 作為 key，hash 變更不重建根視圖。
     */
    routerViewKey() {
      const fp = this.$route.fullPath
      const i = fp.indexOf('#')
      return i === -1 ? fp : fp.slice(0, i)
    },
  },
  watch: {
    loggedIn: {
      handler(newValue, oldValue) {
        if(newValue) {
          if(process.env.VUE_APP_BUILD_MODE === 'admin-app-build') {
            if(this.currentDeviceToken) {
              this.initPushNotifications();
            } else {
              this.tryToRegisterDevice();
            }
          }
          this.initEcho();
        } else {
          this.leaveEcho();
        }
      },
    },
    async keydownContent(value){
      if(value === 'delete'){
        try {
          await this.$confirm('確定要開啟刪除模式嗎？確定後請重整網頁','提醒', {
            confirmButtonText: '確定',
            type: 'warning',
            center: true,
          })
          await saveState('isDeleteMode', true)

        } catch {

        } finally {

        }

      }
    }
  },
  async mounted() {
    this.initPublicEcho()
    if(process.env.VUE_APP_BUILD_MODE === 'admin-app-build') {
      await this.initPushNotifications();
      this.initAppListener();
    }
    if(this.loggedIn){
      this.initEcho();
    }

    // console.log(Notification.permission)
    // console.log('Notification' in window,screen,window)
    if(screen.orientation){
      screen.orientation.addEventListener('change', function() {
        // alert(screen.orientation.type); // e.g. portrait
      });
    }

    this.keydownMethod()
    this.getDeleteMode()
  },
  methods: {
    async getDeleteMode(){
      const isDeleteMode = await getSavedState('isDeleteMode') ?? false
      await saveState('isDeleteMode', isDeleteMode)
    },
    keydownMethod(){
      document.onkeydown = (event) => {
        this.keydownContent =this.keydownContent + event.key
      }
    },
    ...mapActions('push',['addPush']),
    leaveEcho() {
      if(this.echoPrivate) {
        this.$echo
          .leave(this.echoPrivate);
      }
    },
    /**
     * @description 初始化websocket public 頻道
     */
    initPublicEcho(){
      this.$echo.channel('share').listenToAll((event, data) => {
        if(event === 'PushRefreshEvent'){
          window.location.reload()
        }
      })
    },
    /**
     * @description 初始化websocket private 頻道
     */
    initEcho() {
      this.echoPrivate = `pusher.${this.currentUser.id}`;

      this.$echo.connector.options.auth.headers["Authorization"] = `Bearer ${this.currentUser.token}`;

      this.$echo
        .private(this.echoPrivate)
        .subscribed(() => {
          // console.log(`加入Echo頻道: ${this.echoPrivate}`);
        })
        .listenToAll((event, data) => {
          if(process.env.VUE_APP_BUILD_MODE !== 'admin-app-build') {
            if(data.aps) {
              // console.log('notifyBrowser');
              if('Notification' in window){
                this.notifyBrowser(data.aps);
              }
            }
          }
          if(data) {
            this.addPush(data)
            const routeName = router.app.$route.name
            if(routeName === 'notification' || routeName === 'employee-notification'){
              this.$store.dispatch('push/clearUnRead')
            }
            const alert = data.aps.alert
            const url = data.aps.data.url
            const vm = this
            this.$notify({
              title: alert.title,
              message: alert.body,
              customClass:url?'notificationText':'',
              onClick(){
                vm.readPush({
                  pushId: data.aps.data.id
                });
                if(url){
                  window.location = url
                }

              }
            })
          }
        });
    },
    initPushNotifications() {
      // 請求權限
      PushNotifications.requestPermissions()
        .then(result => {
          // console.log('result ' + JSON.stringify(result));

          PushNotifications.register();
        });

      // 註冊應用程序以接收推送通知。
      PushNotifications.addListener('registration', (token) => {
        // console.log('Push registration success, token: ' + token.value);

        if(token.value) {
          this.tryToSetCurrentDeviceToken({
            token: token.value
          })
            .then(() => {
              if(this.loggedIn && this.currentDeviceToken) {
                this.tryToRegisterDevice();
              }
            });
        } else {
          // console.log('need token')
        }
      });

      // 當設備收到推送通知時調用。
      PushNotifications.addListener('pushNotificationReceived', (pushNotificationSchema) => {
          // alert('收到通知: ' + JSON.stringify(pushNotificationSchema));
        }
      );

      // 當對推送通知執行操作時調用。
      PushNotifications.addListener('pushNotificationActionPerformed', (actionPerformed) => {
          const goToUrl = (url) => {
            if(url) {
              window.location = url
            }
          };

          goToUrl(actionPerformed.notification?.data?.aps?.data?.url);

          this.readPush({
            pushId: actionPerformed.notification?.data?.aps?.data?.id
          })
          // alert('點擊通知: ' + JSON.stringify(actionPerformed));
        }
      );
    },
    initAppListener() {
      App.addListener('appStateChange', ({ isActive }) => {
        if(isActive) {
          // PushNotifications.removeAllDeliveredNotifications()
        }
      });
    },
    notifyBrowser(data) {
      const notifyConfig = {
        body: data.alert.body,
        icon: require('@assets/images/notification_avatar.jpg'),
        // icon: data.data.icon || require('@assets/images/notification_avatar.jpg'),
        // tag: data.data.tag
      };

      const notification = new Notification(data.alert.title, notifyConfig);

      notification.onclick = () => {
        const goToUrl = (url) => {
          if(url) {
            window.location = url
          }
        };

        goToUrl(data?.data?.url);
        notification.close();

        this.readPush({
          pushId: data.data.id
        });
      };
    },
    async readPush({ pushId }) {
      this.loadingReadPush = true;

      await this.$store.dispatch('push/readPush', {
        pushId,
      })
        .then(() => {

          return true
        })
        .finally(() => {
          this.loadingReadPush = false
        })
    },
    async tryToRegisterDevice() {
      this.loadingRegisterDevice = true;

      await this.$store.dispatch('device/registerDevice', {
        token: this.currentDeviceToken,
      })
        .then(() => {
          // alert('tryToRegisterDevice success');

          return true
        })
        .finally(() => {
          this.loadingRegisterDevice = false
        })
    },
    async tryToSetCurrentDeviceToken({ token }) {
      this.loadingSetCurrentDeviceToken = true;

      // 商店擁有者,商店管理,小編人員,訂單操作,排班人員
      await this.$store.dispatch('device/setCurrentDeviceToken', {
        token,
      })
        .then(() => {
          // alert('tryToSetCurrentDeviceToken success');

          return true
        })
        .finally(() => {
          this.loadingSetCurrentDeviceToken = false
        })
    },
  }
}
</script>

<template>
  <div id="app">
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <keep-alive v-if="$route.meta.keepAlive">
      <RouterView :key="$route.name"/>
    </keep-alive>
    <RouterView v-else :key="routerViewKey"/>
  
    <!-- <el-dialog
      title="網站以橫向模式瀏覽最佳"
      :visible.sync="lockDialogVisible"
      top="0"
      width="680px"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      center
      lock-scroll
    >
      <p style="text-align: center;">請旋轉您的裝置</p>
    </el-dialog> -->
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
@import '~normalize.css/normalize.css';
// Style loading bar between pages.
// https://github.com/rstacruz/nprogress
@import '~nprogress/nprogress.css';

// Design variables and utilities from src/design.
@import '@src/design/global.scss';
// @import '@src/design/index.scss';

*,
*::before,
*::after {
  box-sizing: border-box;
}

::-webkit-scrollbar {
  display: none;
}

html {
  font-size: 14px;
  line-height: 1.15;
  -webkit-tap-highlight-color: transparent;
  letter-spacing: 0.15em
}

body {
  @extend %font-content;

  // height: 100vh;
  background: $color-body-bg;
  -webkit-overflow-scrolling: touch;
}

// ===
// Base element styles
// ===

a,
a:visited {
  color: $color-link-text;
}

ul {
  padding: 0;
  margin: 0;
  list-style: none;
}

h1 {
  @extend %font-heading;

  font-size: ms(6);
  letter-spacing: $font-letter-spacing-base;
}

h2 {
  @extend %font-heading;

  font-size: ms(5);
  letter-spacing: $font-letter-spacing-base;
}

h3 {
  @extend %font-heading;

  font-size: ms(4);
  margin-block-start: ms(4) / 1.5;
  margin-block-end: ms(4) / 1.5;
  letter-spacing: $font-letter-spacing-base;
}

h4 {
  @extend %font-heading;

  font-size: ms(3);
  margin-block-start: ms(3) / 1.5;
  margin-block-end: ms(3) / 1.5;
  letter-spacing: $font-letter-spacing-base;
}

h5 {
  @extend %font-heading;

  font-size: ms(2);
  margin-block-start: ms(2) / 1.5;
  margin-block-end: ms(2) / 1.5;
  letter-spacing: $font-letter-spacing-small;
}

h6 {
  @extend %font-heading;

  font-size: ms(1);
  margin-block-start: ms(1) / 1.5;
  margin-block-end: ms(1) / 1.5;
  letter-spacing: $font-letter-spacing-small;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: 500;
}

input {
  background: none;
}

img {
  max-width: 100%;
}

[hidden] {
  display: none;
}

// ===
// Vendor
// ===

#nprogress {
  .bar {
    background: $color-primary;
  }

  .spinner-icon {
    border-top-color: $color-primary;
    border-left-color: $color-primary;
  }
}
</style>
